export var DEPLOY_DATE = new Date('2026-07-10T12:11:26+0000');
